import { useStore } from '../store';
import { ROUTES_TO_AVOID_INIT } from '../router/constants';

const shouldAvoidRedirect = (location: string) => {
  let isAvoid = false;
  ROUTES_TO_AVOID_INIT.forEach((route) => {
    if (location.includes(route)) {
      isAvoid = true;
    }
  });
  return isAvoid;
};

export const prepareRedirect = (location: string) => {
  const { setRedirection } = useStore.getState();
  if (location && location !== '/login' && !shouldAvoidRedirect(location)) {
    setRedirection(location);
  } else {
    setRedirection('');
  }
};
